import { Id } from 'types';
import {
  ContractTerm,
  ContractTermCostTierId,
  ContractTermsFormValues,
} from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';

export const createContractTermError = {
  failCreateContractTerm: `Couldn't create contract term`,
};

export const contractTermCreate = async (
  contractId: Id,
  contractTermFormValues: ContractTermsFormValues,
  isAmendment = false,
): Promise<ContractTerm> => {
  const contractTermPayload = {
    isAmendment,
    contractTerm: {
      quantity: contractTermFormValues.quantity,
      breedId: contractTermFormValues.breedId,
      colorIds: contractTermFormValues.colorIds,
      varietyIds: contractTermFormValues.varietyIds,
      breederContractTermTypeId: contractTermFormValues.breederContractTermTypeId,
      costs: [
        {
          breederContractTermCostTierId: ContractTermCostTierId.Initial,
          cost: contractTermFormValues.initialCost,
          price: contractTermFormValues.initialPrice,
        },
        {
          breederContractTermCostTierId: ContractTermCostTierId.Decreased,
          cost: contractTermFormValues.middleCost,
          price: contractTermFormValues.middlePrice,
        },
        {
          breederContractTermCostTierId: ContractTermCostTierId.Final,
          cost: contractTermFormValues.finalCost,
          price: contractTermFormValues.finalPrice,
        },
      ],
    },
  };

  const respContractTerm = await apiContract.postContractTerm(
    contractId,
    contractTermPayload,
  );

  if (!respContractTerm.isOk) {
    throw Error(
      respContractTerm.json?.message || createContractTermError.failCreateContractTerm,
    );
  }

  return respContractTerm.json.contractTerm;
};
